import loadable from '@loadable/component';
import React from 'react';
import {Text, View} from 'react-native';
import styles from './TextWithIconBox.styles';
const SVG = loadable(() => import('../../../../../imports/svg'));

export default function TextWithIconBox(props) {
  const {title, icon, containerStyle} = props;

  return (
    <View style={[styles.container, containerStyle]}>
      <Text style={styles.title}>{title}</Text>
      {icon && <SVG name={icon} width={12} height={12} />}
    </View>
  );
}
